import { Undoable, UndoFn } from '~/models/undoable'

export const noopUndoable = (): Undoable => ({ undo: () => Promise.resolve() })

export const undoable = (undoFn: UndoFn = noopUndoable().undo): Undoable => ({
  undo: undoFn
})
